export default __webpack_public_path__ + "static/PQPS1-31621b33268e4b768187374efd354b5c.png";